import { motion } from "framer-motion";
import { useEffect, useContext } from "react";
import { LanguageContext } from "../../../context/LanguageContext";

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
};

const sectionFade = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

export default function TermsAndConditions() {
  const { t, isRTL } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const sections = t("terms.sections", { returnObjects: true });

  return (
    <section
      dir={isRTL ? "rtl" : "ltr"}
      className="bg-gradient-to-b from-rose-50/50 via-white to-white py-24"
    >
      <div className="mx-auto max-w-4xl px-6">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-20 text-center"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
            {t("terms.title")}
          </h1>
          <p className="mt-4 text-gray-600">
            {t("terms.lastReviewed")}: {new Date().getFullYear()}
          </p>
        </motion.div>

        {/* Content */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="space-y-10"
        >
          {sections.map((section, i) => (
            <motion.div
              key={i}
              variants={sectionFade}
              className="rounded-2xl border bg-white p-8 shadow-sm"
            >
              <h2 className="mb-4 text-xl font-semibold border-l-4 border-rose-600 pl-4">
                {section.title}
              </h2>

              {section.paragraphs?.map((p, idx) => (
                <p key={idx} className="mb-4 text-gray-700">
                  {p}
                </p>
              ))}

              {section.list && (
                <ul className="list-disc pl-6 space-y-2 mb-4">
                  {section.list.map((li, j) => (
                    <li key={j}>{li}</li>
                  ))}
                </ul>
              )}

              {section.grid && (
                <ul className="grid gap-2 sm:grid-cols-2 list-disc pl-6 mb-4">
                  {section.grid.map((g, j) => (
                    <li key={j}>{g}</li>
                  ))}
                </ul>
              )}

              {section.note && (
                <div className="mt-4 rounded-xl border border-rose-200 bg-rose-50 p-4 text-sm">
                  <strong>{section.note}</strong>
                </div>
              )}
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
}
